// extracted by mini-css-extract-plugin
module.exports = {"container_error":"Error_container_error__SSNiX","logo":"Error_logo__2JSRW","content_error":"Error_content_error__3NJ57"};